/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientProgramModel } from '../../models/patient-program-model';
import { PatientProgramPropagateModel } from '../../models/patient-program-propagate-model';

export interface SavePatientProgram$Params {
      body?: PatientProgramPropagateModel
}

export function SavePatientProgram(http: HttpClient, rootUrl: string, params?: SavePatientProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientProgram.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientProgramModel>;
    })
  );
}

SavePatientProgram.PATH = '/api/Supervisor/SavePatientProgram';
